import { RequestParams } from "@/types/common";
import { COOKIE_KEY } from "@/types/cookie";
import { API_MSG } from "@/types/message";
import axios, { AxiosError, AxiosResponse } from "axios";
import { error } from "../components/flash-message";
import { snackbar } from "../components/snackbar/snackbar";
import { redirectToLogin } from "./api.service";
import { restService } from "./rest.service";

// axios cancelled code & cancel controller
const ERR_CANCELLED = "ERR_CANCELED";
let abortController = new AbortController();

const getCookieFromDocument = (name: string) => {
    const matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    // console.log('🚀 ~ file: abstract.service.tsx ~ line 19 ~ getCookieFromDocument ~ matches', matches);
    return matches ? matches[1] : undefined;
}

export default function exec(
    url: string,
    method: 'get' | 'post' | 'put' | 'delete' | 'patch' | 'options',
    data?: any,
    options?: RequestParams,
    hideOverlay?: boolean,
) {
    const timeStart = Date.now();

    const xsrfToken = getCookieFromDocument('XSRF-TOKEN');

    const defaultHeaders = {
        'Content-Type': 'application/json'
    };
    const config: RequestParams = {
        url,
        method,
        data,
        ...options,
        headers: {
            ...defaultHeaders,
            ...options?.headers,
            withCredentials: true,
            ...(xsrfToken ? { 'X-XSRF-TOKEN': decodeURIComponent(xsrfToken) } : {}),
            // Authorization: `Bearer eyJraWQiOiJBMDJpbTBVMTR1WmVvZ1VXIiwiYWxnIjoiUlMyNTYiLCJ0eXAiOiJKV1QifQ.eyJhdWQiOiJJWlE3QVVMV0dteHdmRzlIYjl5WjZDOFRCQzhNREJVVSIsInN1YiI6IjEwMDAyIiwiaXNzIjoiaHR0cHM6Ly9zYWFzLm5leHRzY20uY29tL2FjY291bnQyIiwiZXhwIjoxNzIyMjQ4Njk2LCJpYXQiOjE3MjIyNDUwOTYsImF1dGhfdGltZSI6MTcyMjI0NTA4OCwibmFtZSI6ImFkbWluIiwidXNlcm5hbWUiOiJhZG1pbiIsImF1dGhfbW9kZSI6IkJBU0lDIiwib3JnX25hbWUiOiJpbmNyZWZmIiwiYXBwX25hbWUiOiJhY2NvdW50Iiwib3JnX2lkIjoxMDAwMywic2lkIjoiOGE1MDNiY2Q2ZGFhNTg3NTM1ODQwZWFhNTVmZTVjNDk2MzliYTQxZiIsIm9yZ19yb2xlcyI6IltcImFkbWluXCIsXCJtYW5hZ2VyXCIsXCJzdXBlcmFkbWluXCJdIiwiYXBwX3JvbGVzIjoie1wiYXNzdXJlXCI6W1wiYWRtaW5cIixcImd1ZXN0XCJdLFwiYWNjb3VudFwiOltcInN0YW5kYXJkXCIsXCJpbnRlZ3JhdGlvblwiLFwiYWRtaW5cIixcImd1ZXN0XCJdfSIsInJlc291cmNlX3JvbGVzIjoie1wiYXNzdXJlXCI6e1wic3VwcGxpZXJcIjp7XCJzdXBwbGllcjNcIjpbXCJwYXJ0bmVyXCJdLFwic3VwcGxpZXIyXCI6W1wiYWRtaW5cIixcImRpc3RyaWJ1dGVyXCJdLFwic3VwcGxpZXIxXCI6W1wicGFydG5lclwiLFwiZGlzdHJpYnV0ZXJcIixcInZlbmRlclwiXX0sXCJjbGllbnRcIjp7XCJjbGllbnRcIjpbXCJhZG1pblwiXSxcImNsaWVudDJcIjpbXCJjbGllbnQuc3RhbmRhcmRcIixcImNsaWVudC5hZG1pblwiXSxcImNsaWVudDFcIjpbXCJjbGllbnQuc3RhbmRhcmRcIixcImNsaWVudC5hZG1pblwiXSxcImNsaWVudDBcIjpbXCJjbGllbnQuc3RhbmRhcmRcIixcImNsaWVudC5hZG1pblwiXX0sXCJ3YXJlaG91c2VcIjp7XCJ3YXJlaG91c2UxXCI6W1wid2gucGlja2VyLXBhY2tlclwiXX19fSJ9.QTsEwzm9WAHrCfERoNGJEIUtYuCp1MFuslg7Ry8AcZ_hcO-dTsCVvkZI6-n24Uf0Erqm3sSjTqs9AaNZJyZwPdxScO5YwmmsJ7oepXqV4Sa3N4wc2eRarxXXOqGRaIKkFr1lQfQ2ZiGm9NNh_7-GOzbh1A6585qlyFSTCo7_8xQ1po1-4Pjd4y7j14tA6cG4dzZUzz-KJt5B3RoEferN3meak8SM4rj7mfzqef_btqQCj9E4tv5AXRjxbQZvwnGmVPVhB0Zq5r900GdavlyPCnGDclJGnQ3MfxNM_dMkmDQ9vOubk_zMh-O08Abgihj7N5NOHGePOHeUHTyuDWuNbA`
        }
    };

    // if (cookie) {
    //     config.headers = {
    //         ...config.headers,
    //         Authorization: `Bearer ${cookie}`
    //     };
    // }

    snackbar.wait(hideOverlay);

    return axios({
        ...config,
        signal: abortController.signal,
    }).then((res: AxiosResponse) => {
        snackbar.clear();

        const responseURL = res.request.responseURL;
        // Redirect the browser to the new URL if status code is between 300 and 399 used for redirection
        // check? ->(&& responseURL !== config.url)
        if (res.status === 302 && responseURL) { //Backend will always send 302 incase of them redirecting
            console.log('Redirecting to', responseURL);
            window.location.href = responseURL;
        } else {
            snackbar.success();
            return res?.data;
        }
        // snackbar.success('Successfull');
        // return res?.data;
    }).catch((err: AxiosError) => {
        snackbar.clear();
        snackbar.error();

        if (err.code === ERR_CANCELLED) return;
        let msg,
            errRes: any = err.response?.statusText,
            errObj: any = { message: '', axiosErr: err },
            diff,
            timeEnd = Date.now();
        diff = (timeEnd - timeStart) / 1000;
        try { errObj = typeof errRes === "object" ? errRes : JSON.parse(errRes); }
        catch (error) { }
        finally {
            switch (err.response?.status) {
                case 0: {
                    errObj.message = diff < restService.requestTimeOut ? API_MSG.CONNECTION : API_MSG.TIME_OUT;
                    break;
                }
                case 401: {
                    localStorage.clear();
                    errObj.message = API_MSG.UNAUTHENTICATED;
                    error(errObj?.message);
                    setTimeout(() => redirectToLogin(), 3000);
                    // errRes ? redirectToLogin() : errObj.message = API_MSG.UNAUTHENTICATED;
                    break;
                }
                case 403: {
                    errObj.message = API_MSG.UNAUTHORIZED;
                    error(errObj?.message);
                    window.location.href = '/auth/decide'; // Redirect to auth/decide page
                    // if (errRes) {
                    //     window.location.href = restService.loginAuthorize;
                    //     break;
                    // }
                    break;
                }
                case 404: {
                    errObj.message = API_MSG.NOT_FOUND;
                    error(errObj?.message);
                    break;
                }
                case 502: {
                    errObj.message = API_MSG.TIME_OUT;
                    error(errObj?.message);
                    break;
                }
                default: {
                    errObj.message = !errRes ? API_MSG.UNKNOWN : errRes;
                    if (err.status === 500) error(errObj.message, errObj);
                    else {
                        const responseData: any = errObj?.axiosErr?.response?.data;
                        const fieldErrors = responseData?.errors;
                        // Surface field-level validation messages (e.g. BAD_DATA) instead of the
                        // generic top-level "Input validation failed" message.
                        const fieldMsg = Array.isArray(fieldErrors)
                            ? fieldErrors.map((e: any) => e?.message).filter(Boolean).join('\n')
                            : '';
                        const displayMsg = fieldMsg || responseData?.message || errObj.message;
                        error(displayMsg, err.toJSON());
                    }
                    break;
                }
            }

            console.error('Error obj in abstract service', errObj);
            throw errObj;
        }
    }).finally(() => snackbar.clear());
};

export function cancelRequests() {
    abortController.abort();
    // setting new abort controller for new requests
    abortController = new AbortController();
}

/*
Web Server Errors

0xx Unknown (possibly connection error)

1xx Informational

2xx Success
200 OK

3xx Redirection

4xx Client Error
400 Bad Request
401 Unauthorized
404 Not Found

5xx Server Error
500 Internal Server Error
*/